import { Field } from "formik";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import { STRING_CONSTANT } from "../../../constants/constants";

const FormNumberOfPaperField = (props) => {
  const {
    label,
    fieldName,
    error,
    touched,
    isRequired,
    className,
    handleChange,
    authorPaperFees
  } = props;
  const { kuPaperFeesMapping } = useSelector(
    (state) => state.conferenceDetails
  );

  return (
    <div className={className}>
      <label htmlFor={fieldName} className="form-label">
        {label}
        {isRequired && (
          <span className="text-danger">{STRING_CONSTANT.SPACE}*</span>
        )}
      </label>
      <Field
        as="select"
        className="form-select"
        id={fieldName}
        name={fieldName}
        onChange={handleChange}
      >
        <option value={STRING_CONSTANT.BLANK}>{t("select")}</option>
        {kuPaperFeesMapping?.items.map((item,index) => (
          <option key={item.feesAED + index} value={`${item.feesAED}${STRING_CONSTANT.DOLLAR}${item.noOfPaper}${STRING_CONSTANT.DOLLAR}${index}`}>
            {item.noOfPaper}
          </option>
        ))}
      </Field>
      {authorPaperFees > 0 ? (
        <div className="text-dark">{t("paper-fees-info") + authorPaperFees + STRING_CONSTANT.SPACE + t("aed")}</div>
      ) : (
        STRING_CONSTANT.SPACE
      )}
      {error && touched && authorPaperFees <= 0? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.SPACE
      )}
    </div>
  );
};

export default FormNumberOfPaperField;
